import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    textInput: {
      '& input': {
        padding: theme.spacing(1),
      },
    },
    textarea: {
      overflow: 'auto',
      resize: 'vertical',
      minHeight: '32px',
      maxHeight: '100px',
    },
    clearableInputContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    clearButton: {
      marginLeft: theme.spacing(1),

      '& svg': {
        fontSize: '20px',
      },
    },
    fullWidth: {
      width: '100%',
    },
    marginTopText: {
      marginTop: '24px',
    },
    marginTopOther: {
      marginTop: '32px',
    },
    error: {
      border: `1px solid ${theme.palette.error.main}`,

      '&:focus': {
        outline: 'none',
        boxShadow: `0 0 4px ${theme.palette.error.main}`,
      },
    },
    textFieldWrap: {
      fontSize: 'inherit',
      whiteSpace: 'wrap',
    },
    exceededLengthLimit: {
      color: theme.palette.error.main,
    },
  };
};
